import styled from "styled-components";
import { GrayColors, SolutionColorVariables } from "@smartsuite/types";

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 24px;
`;

export const StyledBack = styled.button`
  min-width: 43px;
  width: 43px;
  height: 43px;
  border-radius: 50%;
  border: 1px solid ${GrayColors["G-1-5"]};
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 1px;
  color: ${SolutionColorVariables.sc1};
  transition: 200ms border-color ease-in;

  &:hover {
    color: ${SolutionColorVariables.sc3};
    border-color: ${GrayColors["G-3"]};
    transition: 200ms border-color ease-in;
  }
`;

export const StyledTitle = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 12px;

  a {
    color: inherit;
  }
`;

export const Underscored = styled.a`
  pointer-events: all;
  text-decoration: underline;
  cursor: pointer;
`;

export const StyledFilterDropdown = styled.div`
  margin-left: auto;
  min-width: 200px;
  --single-select-min-height: 28px;
  --arrow-select-top-position: -3px;
  --select-placeholder-arrow-right: 5px;
  display: flex;
  justify-content: flex-end;

  .single-select {
    border: 1px solid ${GrayColors["G-1-5"]};
    border-radius: 5px;
    background-color: ${GrayColors["G-0"]};
    width: auto;

    &.is-open {
      background-color: ${GrayColors["G-0-5"]};
    }
  }
`;

export const StyledOption = styled.div`
  height: 28px;
  padding: 5px 12px;
`;

export const StyledSelectOption = styled.div`
  display: flex;
  max-width: 180px;
  strong {
    font-weight: 500;
  }
`;
